import React, { useEffect, useState } from 'react'
import {
    ifloorplanStateAdd,
    addPlan
} from 'New/redux/actions/actions';
import { connect } from 'react-redux';

const CropTool = (props) => {
    let planImage = document.createElement('img');
    let screenSizeRatio = window.innerWidth / (window.innerHeight - 46);
    let screenWidth = screenSizeRatio < 1.7777 ? window.innerWidth * 99 / 100 : (window.innerHeight * 99 / 100 - 80) * 1.7777;
    let screenHeight = screenSizeRatio < 1.7777 ? window.innerWidth * 55.69 / 100 : (window.innerHeight * 99 / 100 - 80);
    planImage.src = props.ifloorplanNowState.level[props.levelNowId].plan_level[0].img;

    const updateMarkerPositions = (newState, newCrop) => {
        const oldCrop = {
            width: newState.level[props.levelNowId].plan_level[0].crop_width,
            height: newState.level[props.levelNowId].plan_level[0].crop_height,
            x: newState.level[props.levelNowId].plan_level[0].crop_x,
            y: newState.level[props.levelNowId].plan_level[0].crop_y,
        }

        newState.level[props.levelNowId].images.forEach((value, index) => {
            if (value.cam_pos_x !== 0) {
                value.cam_pos_x = (oldCrop.width * value.cam_pos_x / 100 - newCrop.x + oldCrop.x) / newCrop.width * 100;
                value.cam_pos_y = (oldCrop.height * value.cam_pos_y / 100 - newCrop.y + oldCrop.y) / newCrop.height * 100;
            }
            if (props.image_key === index) {
                props.setCamStyle(prev => ({
                    ...prev,
                    top: `${value.cam_pos_y}%`,
                    left: `${value.cam_pos_x}%`,
                }))
            }
        });
        newState.level[props.levelNowId].panelum.forEach((value, index) => {
            if (value.pos_x !== 50) {
                value.pos_x = (oldCrop.width * value.pos_x / 100 - newCrop.x + oldCrop.x) / newCrop.width * 100;
                value.pos_y = (oldCrop.height * value.pos_y / 100 - newCrop.y + oldCrop.y) / newCrop.height * 100;
            }
            if (props.panelum_key === index) {
                props.setPanelumStyle(prev => ({
                    ...prev,
                    top: value.pos_y,
                    left: value.pos_x,
                }))
            }
        });
        return newState;
    };

    const Done = () => {
        if (!props.isCrop) return;
        const cropPlan = document.getElementsByClassName('ReactCrop__image')[0].getBoundingClientRect();
        const screenEl = document.getElementsByClassName('NewWrapper')[0] ? document.getElementsByClassName('NewWrapper')[0].getBoundingClientRect() : document.getElementsByClassName('PublishedWrapper')[0].getBoundingClientRect();
        const dndEl = document.getElementsByClassName('dnd-wrapper')[0].getBoundingClientRect();
        let newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
        newState.level[props.levelNowId].plan_pos_x = (cropPlan.x + props.cropped.x + screenEl.x - dndEl.x) / screenWidth * 100;
        newState.level[props.levelNowId].plan_pos_y = (cropPlan.y + props.cropped.y + screenEl.y - dndEl.y) / screenHeight * 100;
        newState.level[props.levelNowId].plan_width = props.cropped.width / screenWidth * 100;
        newState = updateMarkerPositions(newState, props.cropPos);
        newState.level[props.levelNowId].plan_level[0].crop_x = props.cropPos.x;
        newState.level[props.levelNowId].plan_level[0].crop_y = props.cropPos.y;
        newState.level[props.levelNowId].plan_level[0].crop_width = props.cropPos.width;
        newState.level[props.levelNowId].plan_level[0].crop_height = props.cropPos.height;
        newState.viewed_mobile_editor = false;
        props.ifloorplanStateAdd(newState);
        let plan_array = props.plans;
        plan_array[props.levelNowId] = props.cropImg.img;;
        props.addPlan(plan_array);
        if (props.setPlanLevel)
            props.setPlanLevel({
                position_x: newState.level[props.levelNowId].plan_pos_x,
                position_y: newState.level[props.levelNowId].plan_pos_y,
                img_width: newState.level[props.levelNowId].plan_width,
                img: props.cropImg.img,
            })
        else {
            props.setPlanWrapStyle({
                position: 'absolute',
                width: newState.level[props.levelNowId].plan_width,
                top: newState.level[props.levelNowId].plan_pos_y,
                left: newState.level[props.levelNowId].plan_pos_x,
            })
            props.setPlanSrc(props.cropImg.img);
        }
        props.setPlanCropWrap({
            ratio: props.cropped.width * props.imgRef.current.naturalWidth / props.imgRef.current.width / planImage.naturalWidth,
            x: -props.cropped.x,
            y: -props.cropped.y,
        })
        props.setIsCrop(false);
        document.getElementsByClassName('topPanelWrap')[0].style.opacity = 1;
    }

    const Cancel = () => {
        props.setIsCrop(false);
        props.setCropPos(props.lastCrop);
        document.getElementsByClassName('topPanelWrap')[0].style.opacity = 1;
    }

    useEffect(() => {
        if (props.isDone) {
            Done();
            props.setIsCrop(false);
            props.setIsDone(false);
        }
    }, [props.isDone]);

    return (
        <div className="topPanelWrap crop"
            style={{ display: props.isCrop ? 'block' : 'none' }}>
            <button className="cropDone"
                onClick={Done}>
                Done
            </button>
            <button className="cropCancel"
                onClick={Cancel}
                style={{
                    background: "#1276EB",
                }}>
                Cancel
            </button>
        </div>
    )
}

const putState = (state) => {
    return {
        ifloorplanNowState: state.ifloorplanNowState,
        levelNowId: state.levelNowId,
        step: state.step,
        plans: state.plans,
        image_key: state.image_key,
        pannellum_key: state.pannellum_key,
    }
}

const putActions = (dispatch) => {
    return {
        ifloorplanStateAdd: (plan) => dispatch(ifloorplanStateAdd(plan)),
        addPlan: (plan) => dispatch(addPlan(plan)),
    }
}

export default connect(putState, putActions)(CropTool);